import * as types from './constants'

const initialState = {
  user: {},
  progress: [],
  searchValue: '',
  isLoading: false,
  certificateShowing: false,
  feedbackShowing: false,
  selectedCourse: null,
  employeeStores: '',
  selectedEmployeeTab: '',
  isShowingReason: false,
  isShowingSubmission: false,
  message: '',
  exemptMessage: false,
  exemptCourses: [],
  currentSelectedCourse: null,
  currentSubmission: null,
  employeeLibrary: [],
  employeeId: '',
}

const employeeReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PROGRESS:
      return {
        ...state,
        ...action.data,
      }
    case types.SET_PROGRESS_FILTERED:
      return {
        ...state,
        progress: action.data,
      }
    case types.RESET_PROGRESS:
      return initialState

    case types.SET_SERACH_VALUE:
      return {
        ...state,
        searchValue: action.value,
      }
    case types.LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
      }
    case types.SET_SHOW_CERTIFICATE:
      return {
        ...state,
        certificateShowing: true,
        selectedCourse: action.value,
      }
    case types.SET_HIDE_CERTIFICATE:
      return {
        ...state,
        certificateShowing: false,
        selectedCourse: null,
      }
    case types.SET_SHOW_FEEDBACK:
      return {
        ...state,
        // certificateShowing: true,
        feedbackShowing: true,
        // selectedCourse: action.value,
      }
    case types.SET_EMPLOYEE_STORES:
      return {
        ...state,
        employeeStores: action.data,
      }
    case types.SET_EMPLOYEE_SELECTED_TAB:
      return {
        ...state,
        selectedEmployeeTab: action.value,
      }
    case types.SET_EXEMPT_COURSES:
      return {
        ...state,
        exemptCourses: action.data,
      }
    case types.SET_TOGGLE_REASON_OVERLAY:
      return {
        ...state,
        isShowingReason: action.isShowingReason,
      }
    case types.SET_CURRENT_SELECTED_COURSE:
      return {
        ...state,
        currentSelectedCourse: action.currentSelectedCourse,
      }
    case types.SET_MESSAGE:
      return {
        ...state,
        message: action.message,
      }
    case types.SET_SUBMISSION_SHOWING:
      return {
        ...state,
        isShowingSubmission: action.isShowingSubmission,
      }
    case types.SET_CURRENT_SUBMISSION:
      return {
        ...state,
        currentSubmission: action.currentSubmission,
      }
    case types.EMPLOYEE_LIBRARY:
      return {
        ...state,
        employeeLibrary: action.data,
      }

    case types.SET_EMPLOYEE_ID:
      return {
        ...state,
        employeeId: action.payload,
      }
    case types.SET_USER_MANUALLY:
      return {
        ...state,
        user: action.payload,
      }
    default:
      return state
  }
}

export default employeeReportReducer
